export interface MailPostResonse {
    success: boolean
    message: string
    error?: number
}

export const handleMailResponse = (
    response: MailPostResonse,
): {
    success: boolean
    message: string
    errorCode: number
} => {
    return {
        success: response.success ? true : false,
        message: response.message,
        errorCode: response.error,
    }
}
